function testEmail(email) {
  let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
  return reg.test(email);
}

function minLength(value, len) {
  if (!len) return value.length === 0
  else return value.length < len
}

function testNameForCard(value) {
  let reg = /^[a-z]+\s+[a-z]+(-[a-z]+)?$/iu;
  return reg.test(value);
}

function testLastname(value) {
  let reg = /^[а-яё\s]+(-[а-яё\s]+)?$/iu;
  return reg.test(value);
}

function testFirstname(value) {
  let reg = /^[а-яё]+$/iu;
  return reg.test(value);
}

function testMiddlename(value) {
  let reg = /^[а-яё]+$/iu;
  return reg.test(value);
}

function testDate(value) {
  // if (!(/^\d\d\.\d\d\.\d{4}$/).test(value)  !(/^\d\d-\d\d-\d{4}$/).test(value)) return false

  // let d = value.split('.');
  // if (d.length === 0) d = value.split('-')


  // if (!parseInt(d[1], 10) || parseInt(d[1], 10) > 12) return false
  // if (new Date (parseInt(d[2], 10), d[1] - 1, parseInt(d[0], 10)).getMonth() == d[1]) return false
  // return true;

  if (!value) return false

  let d = value.split('.');
  if (d.length === 1) d = value.split('-')
  
  const date = new Date(d[2], d[1], d[0])
  return date != 'Invalid Date'
}

function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
}

function minDate(valueYear, date) {
  const d = new Date(date)
  return d.getFullYear() < valueYear
}

function maxDate(maxDate, date) {
  const d = new Date(date)
  const md = new Date(maxDate)
  return d > md
}

function trim(str) {
    return str.replace(/^\s+/, '').replace(/\s+$/, '');
}

export { testEmail, minLength, testDate, isNumber, minDate, maxDate, testLastname, trim, testFirstname, testMiddlename, testNameForCard }
